"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const index_1 = require("../index");
/*
 * Read the docs here {@link https://reactjs.org/docs/error-boundaries.html}
 *
 * Error boundaries catch errors during rendering, in lifecycle methods, and in
 * constructors of the whole tree below them.
 **/
class ErrorBoundary extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = { error: undefined };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { error };
    }
    componentDidCatch(error, errorInfo) {
        index_1.Log.error(error, {
            context: [{ name: "Component stack", data: Object.assign({}, errorInfo) }],
        });
    }
    render() {
        const { fallback, children } = this.props;
        const { error } = this.state;
        if (error && fallback) {
            if (typeof fallback === "function") {
                return fallback(error);
            }
            else {
                return fallback;
            }
        }
        return children;
    }
}
exports.default = ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.component.js.map